import React from 'react';

interface AddressSectionProps {
    jobsiteData: any;
}

const AddressSection: React.FC<AddressSectionProps> = ({ jobsiteData }) => {
    // More defensive approach to handle all possible null/undefined scenarios
    const getAddressData = () => {
        // Handle case where jobsiteData is null/undefined
        if (!jobsiteData) {
            return {};
        }
        
        // Handle case where address is null/undefined
        if (!jobsiteData.address) {
            return {};
        }
        
        // Handle case where address is an array
        if (Array.isArray(jobsiteData.address)) {
            return jobsiteData.address.length > 0 ? jobsiteData.address[0] || {} : {};
        }
        
        // Handle case where address is an object
        if (typeof jobsiteData.address === 'object') {
            return jobsiteData.address;
        }
        
        // Fallback to empty object
        return {};
    };

    const address = getAddressData();

    return (
        <div className='bg-white rounded-md shadow mb-4'>
            <div className='p-4 sm:p-6'>
                <h2 className='text-[20px] font-[700] mb-3'>Address</h2>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <div className='mb-3'>
                        <p className='text-[16px] font-[700] text-black'>Address Line 1</p>
                        <p className='text-[16px] font-[500]'>{address?.address1 || '-'}</p>
                    </div>
                    <div className='mb-3'>
                        <p className='text-[16px] font-[700] text-black'>Address Line 2</p>
                        <p className='text-[16px] font-[500]'>{address?.address2 || '-'}</p>
                    </div>
                    <div className='mb-3'>
                        <p className='text-[16px] font-[700] text-black'>City</p>
                        <p className='text-[16px] font-[500]'>{address?.city || '-'}</p>
                    </div>
                    <div className='mb-3'>
                        <p className='text-[16px] font-[700] text-black'>Postal Code</p>
                        <p className='text-[16px] font-[500]'>{address?.postalCode || '-'}</p>
                    </div>
                    <div className='mb-3'>
                        <p className='text-[16px] font-[700] text-black'>Province</p>
                        <p className='text-[16px] font-[500]'>{address?.province?.name || '-'}</p>
                    </div>
                    {/* <div className='mb-3'>
                        <p className='text-[16px] font-[700] text-black'>Board Area</p>
                        <p className='text-[16px] font-[500]'>{address?.boardArea?.name || '-'}</p>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default AddressSection; 